import React from 'react';
import { Box } from '@chakra-ui/react';
import { ff } from '../../../theme';

/** Stylized wallet graphic — matches payout intro modal mockup. */
const WalletIntroIllustration: React.FC = () => (
  <Box
    as="svg"
    viewBox="0 0 160 120"
    w="160px"
    h="120px"
    mx="auto"
    display="block"
    aria-hidden
  >
    <path
      d="M18 58c0-4 3-7 7-7h18"
      stroke={ff.faint}
      strokeWidth="3"
      strokeLinecap="round"
      fill="none"
      opacity="0.9"
    />
    <path
      d="M12 52c0-4 3-7 7-7"
      stroke={ff.faint}
      strokeWidth="3"
      strokeLinecap="round"
      fill="none"
      opacity="0.55"
    />
    <path
      d="M24 64c0-4 3-7 7-7"
      stroke={ff.faint}
      strokeWidth="3"
      strokeLinecap="round"
      fill="none"
      opacity="0.35"
    />

    <rect x="38" y="34" width="88" height="62" rx="16" fill={ff.ink} />
    <rect x="46" y="42" width="72" height="46" rx="12" fill={ff.inkSoft} />

    <rect x="52" y="18" width="34" height="44" rx="6" fill="white" />
    <rect x="58" y="24" width="22" height="3" rx="1.5" fill={ff.border} />
    <rect x="58" y="31" width="18" height="3" rx="1.5" fill={ff.line} />
    <rect x="58" y="38" width="20" height="3" rx="1.5" fill={ff.line} />

    <circle cx="108" cy="28" r="16" fill="#AED923" />
    <circle cx="108" cy="28" r="12" fill={ff.lime} />
    <text
      x="108"
      y="33"
      textAnchor="middle"
      fontSize="14"
      fontWeight="600"
      fill={ff.ink}
      fontFamily="Archivo, system-ui, sans-serif"
    >
      $
    </text>

    <rect x="92" y="58" width="28" height="22" rx="6" fill={ff.lime} />
    <circle cx="106" cy="69" r="4" fill={ff.ink} />

  </Box>
);

export default WalletIntroIllustration;
